import { Calendar } from "react-date-range";
import { TimePicker, TimePickerProps } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from "react";
import PopupModal from "../../../../employee/employee-details/employee-profile/modal/PopupModal";
import { useDispatch } from "react-redux";
import { setPermissionTimingInString } from "../../../../../redux/slices/leaveReportPayloadSlice";
import { useSelector } from "react-redux";


// Define props type for SingleMonth component
interface SingleMonthProps {
  dateRange: Date;
  setSingleDate?: (date: Date) => void;
  setFieldValue: any,
  setDateErrorMessage: (value: string) => void;
  values?: any,
  setErrorMessage: (value: string) => void;
  errorMessage?: string;

}

export default function SingleMonth({ dateRange, setSingleDate, setDateErrorMessage, setFieldValue, values, errorMessage, setErrorMessage }: SingleMonthProps) {
  const format = 'hh:mm A';
  const permissionBalanceCount = useSelector((state: any) => state?.leaveReportPayload?.permissionCount);

  const [selectedDate, setSelectedDate] = useState<Date>(dateRange);
  const [modalerrMessage, setModalErrMessage] = useState('')
  const [popModal, setPopModal] = useState(false)
  const [modalResponse, setModalResponse] = useState('')
  const [modalButtonShow, setmodalButtonShow] = useState(true);
  const permissionTimings = useSelector((state: any) => state?.leaveReportPayload?.permissionTimingInString);

  const dispatch = useDispatch();

  const handleChange = (el: any) => {
    const rangeDate = {
      startDate: el,
      endDate: el
    }
    setFieldValue("leaveDate", rangeDate);
    setDateErrorMessage('')
  }

  const handleClosePopUpModal = () => {
    setPopModal(false)
  }

  const starTimeEventListener: TimePickerProps['onChange'] = (time, timeString) => {
    const selectedTime = dayjs(time);
    const minStartTime = dayjs().hour(8).minute(59);
    const maxStartTime = dayjs().hour(18).minute(30);

    if (selectedTime.isBefore(minStartTime) || selectedTime.isAfter(maxStartTime)) {
      setErrorMessage('Invalid start time')
      setFieldValue('permissionStartTime', '');
      setFieldValue('permissionEndTime', '');
      dispatch(setPermissionTimingInString({
        ...permissionTimings,
        endTime: "",
        startTime: ""
      }))
      return
    } else if (time) {
      setErrorMessage('');
      setFieldValue('permissionStartTime', time ? dayjs(time) : '');
      setFieldValue('permissionEndTime', '');
      dispatch(setPermissionTimingInString({
        ...permissionTimings,
        startTime: timeString,
        endTime: "",
      }))
    } else {
      setFieldValue('permissionStartTime', '');
      setFieldValue('permissionEndTime', '');
      dispatch(setPermissionTimingInString({
        ...permissionTimings,
        endTime: "",
        startTime: ""
      }))
    }

  };

  const endTimeEventListener: TimePickerProps['onChange'] = (time, timeString) => {
    const startTime = values.permissionStartTime;
    const maxEndTime = dayjs(startTime).add(permissionBalanceCount > 1 ? 1 : permissionBalanceCount, 'hour');
    const maxStartTime = dayjs().hour(18).minute(31);
    const selectedEndTime = dayjs(time);
    const timeDiff1hr = selectedEndTime.diff(dayjs(startTime), 'minute');
    if (!startTime || !time) {

      setFieldValue('permissionEndTime', '');
      setErrorMessage('Start time and End time are required.');
      return;
    }

    if (timeDiff1hr < 60) {
      setErrorMessage('Permission request must be at least 1 hour.');
      setFieldValue('permissionEndTime', '');
      dispatch(setPermissionTimingInString({
        ...permissionTimings,
        endTime: "",
      }));
      return;
    } else if (timeDiff1hr > 90) {
      setErrorMessage('Permission request must be at less then 1.5 hour.');
      setFieldValue('permissionEndTime', '');
      dispatch(setPermissionTimingInString({
        ...permissionTimings,
        endTime: "",
      }));
      return;
    }

    else if (selectedEndTime.isAfter(maxStartTime)) {
      setErrorMessage('');
      setFieldValue('permissionEndTime', '');
      dispatch(setPermissionTimingInString({
        ...permissionTimings,
        endTime: "",
      }))
    } else if (time) {

      setErrorMessage('');
      setFieldValue('permissionEndTime', time ? dayjs(time) : '');
      dispatch(setPermissionTimingInString({
        ...permissionTimings,
        endTime: timeString
      }))
    } 
  }

  const disableEndTime = (selectedStartTime: dayjs.Dayjs | null) => {
    if (!selectedStartTime) return {};

    // Calculate min time and max time dynamically based on maxTimeDelta
    const minTime = selectedStartTime.add(1, 'minute');
    const maxTime = selectedStartTime.add(permissionBalanceCount > 1 ? 1.5 : permissionBalanceCount, 'hour');

    return {
      disabledHours: () => {
        const allHours = Array.from({ length: 24 }, (_, i) => i);
        return allHours.filter(hour => hour < minTime.hour() || hour > maxTime.hour() || HandleDisableHours().includes(hour));
      },
      disabledMinutes: (selectedHour: number) => {
        if (selectedHour === minTime.hour()) {
          return Array.from({ length: minTime.minute() }, (_, i) => i);
        }
        if (selectedHour === maxTime.hour()) {
          return Array.from({ length: 60 }, (_, i) => i).slice(maxTime.minute() + 1);
        }
        return [];
      },
    };
  };


  const HandleDisableHours = () => {
    const disabledHours = [];
    for (let i = 0; i < 9; i++) {
      disabledHours.push(i); // Disable before 9 AM
    }
    for (let i = 19; i < 24; i++) {
      disabledHours.push(i); // Disable after 6 PM
    }
    return disabledHours;
  };

  const HandleDisableMinutes = (selectedHour: number) => {
    if (selectedHour === 9) {
      return Array.from({ length: 30 }, (_, i) => i); // Disable 0-29 for 9 AM
    }
    if (selectedHour === 18) {
      return Array.from({ length: 29 }, (_, i) => i + 31); // Disable 31-59 for 6 PM
    }
    return [];
  };

  return (
    <div className="flex flex-wrap md:flex-nowrap justify-between w-full oneMonth">
      <div className="w-full lg:w-[50%]">
        <Calendar
          color="#d34a7c"
          date={values?.leaveDate?.startDate}
          onChange={(value) => {
            if (value instanceof Date) {
              handleChange(value);
            }
          }}
        />
      </div>
      <div className="w-full lg:w-[50%] pt-0 lg:pt-10 pb-5 lg:pb-0 pl-0 lg:pl-10 pr-0 lg:pr-6 Leave-TimePicker">
        <p className="pb-3 font-rubik text-[14px] lg:text-[18px]">Select start & end time</p>

        <div className=" flex">
          <TimePicker
            format={format}
            onChange={starTimeEventListener}
            value={values?.permissionStartTime}
            defaultOpenValue={dayjs().hour(9).minute(30)}
            className="mr-3 Leave-TimePicker w-[175px]"
            disabledHours={HandleDisableHours}
            disabledMinutes={HandleDisableMinutes}
            inputReadOnly={true}
          />

          <TimePicker
            format={format}
            onChange={endTimeEventListener}
            className="Leave-TimePicker w-[175px]"
            value={values?.permissionEndTime}
            defaultOpenValue={values?.permissionStartTime ? dayjs(values.permissionStartTime).add(1, "minute") : undefined}
            disabledTime={() => disableEndTime(values?.permissionStartTime) || errorMessage !== ""}
            inputReadOnly={true}
          />
        </div>
        {errorMessage !== '' && <p className=" text-red-500 font-rubik">{errorMessage}</p>}
      </div>
      {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
    </div>
  )
}